function dictionarySort(arr1, str = 'dicValue') {
    arr1.sort(function(a, b) {
        const pattern = /^[a-zA-Z]+$/;
        let stra = a[str].replace(/\s/g, "");
        let strb = b[str].replace(/\s/g, "");
        if (pattern.test(stra) && pattern.test(strb)) {
            return (stra + "").localeCompare(strb + "");
        } else {
            return 0;
        }
    });
}
export default dictionarySort;